import { AxiosError } from 'axios';
import { FormMessage } from '../form/form';
import { cn } from '@/lib/utils';

export type ResponseErrorProps = {
  error:
    | AxiosError<{
        message: string;
      }>
    | undefined
    | string;
  'data-testid'?: string;
  justify?: 'start' | 'end';
  messageClassName?: string;
};

export const ResponseError = ({
  error,
  'data-testid': testId = 'response-error',
  justify = 'end',
  messageClassName,
}: ResponseErrorProps) => {
  if (!error) {
    return null;
  }
  return (
    <div
      className={cn(
        'flex py-2',
        justify === 'start' && 'justify-start',
        justify === 'end' && 'justify-end',
      )}
      data-testid={testId}
    >
      <FormMessage
        type="error"
        data-testid={`${testId}-message`}
        className={messageClassName}
      >
        {typeof error === 'string'
          ? error
          : error?.response?.data?.message || 'Oops, an unknown error occurred'}
      </FormMessage>
    </div>
  );
};
